import AbstractCommand from "./AbstractCommand";

export default class DestroyCommand extends AbstractCommand {

    /**
     * Executes project specific code when app.destroy is called (onbeforeunload)
     * Everything in this command should be sync because else there is no guarantee it will complete in time.
     * @param {soma.EventDipatcher} dispatcher 
     */
    constructor(dispatcher, destroyEventList) {
        super(dispatcher);

        this.execute = function(event) {
            if (destroyEventList) {
                console.log(`DestroyCommand.execute, ${destroyEventList.length} events to dispatch.`);
                destroyEventList.forEach(eventType => {
                    console.log(`.. dispatching: ${eventType}`);
                    this.dispatch(eventType);
                })
            }
        }
    }

}